import { DomainError } from "../errors/DomainError";

export interface Money {
  amount: number;
  currency: string;
}

export class InvalidMoneyError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = "InvalidMoneyError";
  }
}

export const createMoney = (amount: number, currency: string): Money => {
  if (!Number.isFinite(amount) || amount < 0) {
    throw new InvalidMoneyError("El monto debe ser un número finito y no negativo");
  }

  if (!currency) {
    throw new InvalidMoneyError("La moneda es obligatoria");
  }

  return Object.freeze({ amount, currency });
};
